<script>
import '@/scss/main.scss'
import { mapState, mapGetters } from 'vuex'
import HeaderCentral from '@/components(new)/layout/Headers/HeaderCentral/HeaderCentral.vue'
import ProfileButton from '@/components(new)/UI/Buttons/ProfileButton/ProfileButton.vue'

export default {
  name: 'LayoutBase',
  components: {
    HeaderCentral,
    ProfileButton
  },
  data () {
    return {}
  },
  computed: {
    ...mapState({
      LOGO: state => state.userInterface.dadosEstado.LOGO
    }),
    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),
    getNomeUsuario () {
      if (!this.usuario) return
      return this.usuario.pessoa.nomeRazaoSocial
    },
    getPerfil () {
      if (!this.usuario) return
      return this.usuario.perfilSelecionado ? this.usuario.perfilSelecionado.nome : null
    },
    hasNotificacao () {
      return this.usuario && this.notificacao
    }
  },
  methods: {
    irParaSelecaoModulos () {
      this.$router.push({ name: 'selecionarModulo' })
    },
    async sair () {
      this.$router.push({ name: 'logout' })
    }
  }
}
</script>

<template>
  <div class="layout-base">
    <HeaderCentral
      :imageLogoSrc="require('@/assets/images/logo.png')"
      descricaoLogo="Sistema de Cadastro e Regularização Fundiária"
    >
      <template #RightButtons>
        <ProfileButton
          :nameUser="getNomeUsuario"
          :namePerfil="getPerfil"
          :emailUser="`${usuario.pessoa.email}`"
          :opcoesProfileButton="[
            { text: 'Módulos', action: () => irParaSelecaoModulos() },
          ]"
          :ButtonSair="{ text: 'Sair', action: () => sair() }"
        />
      </template>
    </HeaderCentral>
    <div class="main">
      <router-view />
      <slot></slot>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/layout/LayoutBases/LayoutCentral/LayoutCentral.vue